import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";

const CloseMultipleAnnouncementApiService = async (announcementIds: number[]): Promise<Results> => {
  const url = `/announcements/close_or_delete/`;
  const { data } = await axios.post(url, { ids: announcementIds});
  return data;
};

type Results = {
  closed: number;
  deleted: number;
  ignored: number;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useCloseMultipleAnnouncementApiService = () =>
  useMutation<Results, AxiosError, number[]>(
    CloseMultipleAnnouncementApiService, {
      mutationKey: "CloseMultipleAnnouncementApiService"
    }
  );
export default useCloseMultipleAnnouncementApiService;